import { render } from "./clipboardTextInput.vue?vue&type=template&id=e2db44dc"
import script from "./clipboardTextInput.vue?vue&type=script&lang=js"
export * from "./clipboardTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__